import React from 'react'
import './fog.scss'

export default function Fog() {
  return (
    <div class="fog"><div></div></div>
  )
}
